<template>
  <IndexPageSection
    :link-string="'もっと見る'"
    :link-url="'/scenes'"
    :need-to-move-link-to-bottom="false"
    :section-name="'scene-list-section'"
    :title="'シーンから探す'"
  >
    <div v-if="isScenesLoading" class="scene-list-section__loading">
      <Loading />
    </div>
    <HorizontalScroll v-else ref="scene-list-horizontal" ref-name="scene-list">
      <SceneList :scenes="scenes" @mount="onMountSceneList" />
    </HorizontalScroll>
  </IndexPageSection>
</template>
<script>
import IndexPageSection from './IndexPageSection'
import SceneList from './scenes/SceneList'
import Loading from '../../../atoms/loadings/Loading'
import axios from 'axios'
import HorizontalScroll from '../../../molecules/horizontal-scrolls/HorizontalScroll'

export default {
  components: { HorizontalScroll, IndexPageSection, SceneList, Loading },
  data() {
    return {
      scenes: [],
      isScenesLoading: false
    }
  },
  mounted() {
    this.getScenes()
  },
  methods: {
    async getScenes() {
      this.isScenesLoading = true
      try {
        const res = await axios.get('/api/v1/pickup/scenes')
        this.scenes = res.data.data
          .map(scene => scene.attributes)
          .map(({ id, name, top_image_url }) => ({
            id,
            name,
            imageUrl: top_image_url
          }))
        this.isScenesLoading = false
      } catch (error) {
        this.isScenesLoading = false
        const message =
          error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : '情報の取得に失敗しました。しばらく経ってから再度アクセスしてください'
        this.$emit('error', message)
      }
    },
    onMountSceneList() {
      this.$refs['scene-list-horizontal'].initializeValues()
    }
  }
}
</script>
